<template>
  <div>
    <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
      :class="isShowPayment ? 'show_card' : 'show_card header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShowWechat">
        <span style="font-weight: bold;font-size: 14px;color: #636569">垫付款认领流程</span>
        <i class="el-icon-arrow-up" v-show="isShowPayment"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShowPayment"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
      </div>
      <el-descriptions v-show="isShowPayment" style="margin-bottom: 0;font-size: 13px!important;" border :column="1">
        <el-descriptions-item label="正式合同申请认领垫付款">
          <!-- 垫付款认领流程图：SVG 绘制，整体横向布局，N6 → N7 直接水平相连不拐弯 -->
          <div class="payment-flowchart">
            <svg viewBox="0 0 1340 260" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <marker id="pfcArrow" markerWidth="10" markerHeight="10" refX="9" refY="5" orient="auto">
                  <polygon points="0 0, 10 5, 0 10" fill="#8a8f99"/>
                </marker>
              </defs>

              <!-- 连线（先绘制在底层，节点覆盖其上） -->
              <g stroke="#8a8f99" stroke-width="1.2" fill="none">
                <!-- 1 → 2 -->
                <line x1="120" y1="130" x2="148" y2="130" marker-end="url(#pfcArrow)"/>
                <!-- 2 → 分支：主干 -->
                <line x1="230" y1="130" x2="260" y2="130"/>
                <!-- 分支竖线 -->
                <line x1="260" y1="50" x2="260" y2="210"/>
                <!-- 上分支：进入 N3 -->
                <line x1="260" y1="50" x2="288" y2="50" marker-end="url(#pfcArrow)"/>
                <!-- 下分支：进入 N5 -->
                <line x1="260" y1="210" x2="288" y2="210" marker-end="url(#pfcArrow)"/>
                <!-- 3 → 4 -->
                <line x1="420" y1="50" x2="448" y2="50" marker-end="url(#pfcArrow)"/>
                <!-- 汇聚：上支下来 -->
                <line x1="560" y1="50" x2="590" y2="50"/>
                <line x1="590" y1="50" x2="590" y2="130"/>
                <!-- 汇聚：下支上来 -->
                <line x1="550" y1="210" x2="590" y2="210"/>
                <line x1="590" y1="210" x2="590" y2="130"/>
                <!-- 汇聚点 → N6 -->
                <line x1="590" y1="130" x2="618" y2="130" marker-end="url(#pfcArrow)"/>
                <!-- N6 → N7：水平直线，不拐弯 -->
                <line x1="880" y1="130" x2="908" y2="130" marker-end="url(#pfcArrow)"/>
              </g>

              <!-- 节点 -->
              <g font-size="13" fill="#303133">
                <!-- N1: 申请认领垫付款 -->
                <rect x="10" y="110" width="110" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="65" y="134" text-anchor="middle">申请认领垫付款</text>

                <!-- N2: 申请通过 -->
                <rect x="150" y="110" width="80" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="190" y="134" text-anchor="middle">申请通过</text>

                <!-- N3: 项目正常开票到款（分支A - 上） -->
                <rect x="290" y="30" width="130" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="355" y="54" text-anchor="middle">项目正常开票到款</text>

                <!-- N4: 项目全款到账 -->
                <rect x="450" y="30" width="110" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="505" y="54" text-anchor="middle">项目全款到账</text>

                <!-- N5: 项目在预付款余额充足下变更为扣款合同（分支B - 下） -->
                <rect x="290" y="190" width="260" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="420" y="214" text-anchor="middle">项目在预付款余额充足下变更为扣款合同</text>

                <!-- N6: 该项目自动流转到罗嗣连，罗嗣连安排退款（汇聚） -->
                <rect x="620" y="110" width="260" height="40" rx="4" fill="#f0f9eb" stroke="#67c23a" stroke-width="1"/>
                <text x="750" y="134" text-anchor="middle">该项目自动流转到罗嗣连，罗嗣连安排退款</text>

                <!-- N7: 管理系统检测到商务系统该合同有垫付款...（双行文本） -->
                <rect x="910" y="102" width="410" height="56" rx="4" fill="#f0f9eb" stroke="#67c23a" stroke-width="1"/>
                <text x="1115" y="124" text-anchor="middle">管理系统检测到商务系统该合同有垫付款，</text>
                <text x="1115" y="144" text-anchor="middle">自动提交原始数据/纯分析结果审批/自动审批/自动交付结果和数据</text>
              </g>
            </svg>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="预付款合同申请认领垫付款">
          <!-- 预付款合同垫付款认领流程图：无分支的线性横向布局，N5 长文本拆为双行 -->
          <div class="payment-flowchart">
            <svg viewBox="0 0 1180 120" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <marker id="pfcArrow2" markerWidth="10" markerHeight="10" refX="9" refY="5" orient="auto">
                  <polygon points="0 0, 10 5, 0 10" fill="#8a8f99"/>
                </marker>
              </defs>

              <!-- 连线：全部为水平直线 -->
              <g stroke="#8a8f99" stroke-width="1.2" fill="none">
                <line x1="120" y1="60" x2="148" y2="60" marker-end="url(#pfcArrow2)"/>
                <line x1="230" y1="60" x2="258" y2="60" marker-end="url(#pfcArrow2)"/>
                <line x1="450" y1="60" x2="478" y2="60" marker-end="url(#pfcArrow2)"/>
                <line x1="695" y1="60" x2="723" y2="60" marker-end="url(#pfcArrow2)"/>
              </g>

              <!-- 节点 -->
              <g font-size="13" fill="#303133">
                <!-- N1: 申请认领垫付款 -->
                <rect x="10" y="40" width="110" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="65" y="64" text-anchor="middle">申请认领垫付款</text>

                <!-- N2: 申请通过 -->
                <rect x="150" y="40" width="80" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="190" y="64" text-anchor="middle">申请通过</text>

                <!-- N3: 该款导入到客户的：剩余金额 -->
                <rect x="260" y="40" width="190" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="355" y="64" text-anchor="middle">该款导入到客户的：剩余金额</text>

                <!-- N4: 系统检查到该预付款合同全款到账 -->
                <rect x="480" y="40" width="215" height="40" rx="4" fill="#ecf5ff" stroke="#409eff" stroke-width="1"/>
                <text x="587" y="64" text-anchor="middle">系统检查到该预付款合同全款到账</text>

                <!-- N5: 该项目自动流转... 注意...（双行文本） -->
                <rect x="725" y="32" width="440" height="56" rx="4" fill="#f0f9eb" stroke="#67c23a" stroke-width="1"/>
                <text x="945" y="54" text-anchor="middle">该项目自动流转到罗嗣连，罗嗣连安排退款，该客户剩余金额-垫付款；</text>
                <text x="945" y="74" text-anchor="middle" fill="#f56c6c">注意：如果剩余金额小于垫付款，不会流转到罗嗣连</text>
              </g>
            </svg>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
        <el-button size="small"
          v-if="!['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'].includes(role) && activeTab === 'claim'"
          type="success" icon="el-icon-plus" @click="handleAdd()">添加
        </el-button>
        <el-button size="small"
          v-if="!['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'].includes(role) && ['ALL','RECEIVABLES','PARTIAL_ARRIVAL'].includes(activeTab)"
          type="primary" icon="el-icon-plus" @click="handleInvoiceAdd()">合并添加到款
        </el-button>
        <el-button size="small" v-if="['ADMIN','FINANCE','CASHIER'].includes(role) && activeTab === 'claim'"
          type="danger" icon="el-icon-delete" @click="handleDelete()">批量删除
        </el-button>
      </div>
      <export-components v-if="['ALL','RECEIVABLES','PARTIAL_ARRIVAL','PAYMENT'].includes(activeTab)" :apiFunction="exportInvoice"
        :requestData="getSearch(getBaseSendData())" :option="option" @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane label="全部" name="ALL"></el-tab-pane>
      <el-tab-pane label="未到款" name="RECEIVABLES">
       <span slot="label">
          <el-badge style="margin-top: 10px;margin-bottom: 10px"
            :value="pageTotal['RECEIVABLES'] === 0 ? '' : pageTotal['RECEIVABLES']" :max="99">未到款</el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane label="部分到款" name="PARTIAL_ARRIVAL">
        <span slot="label">
          <el-badge style="margin-top: 10px;margin-bottom: 10px"
            :value="pageTotal['PARTIAL_ARRIVAL'] === 0 ? '' : pageTotal['PARTIAL_ARRIVAL']" :max="99">部分到款</el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane label="全部到款" name="PAYMENT"></el-tab-pane>
      <el-tab-pane label="待认领" name="claim">
       <span slot="label">
          <el-badge style="margin-top: 10px;margin-bottom: 10px"
            :value="pageTotal['claim'] === 0 ? '' : pageTotal['claim']" :max="99">待认领</el-badge>
        </span>
      </el-tab-pane>
      <el-tab-pane label="认领记录" name="claimHistory"></el-tab-pane>
      <el-tab-pane label="删除到款记录" name="deleteHistory"></el-tab-pane>
    </el-tabs>
    <el-tabs v-if="activeTab === 'claimHistory'" v-model="claimHistorySubTab" @tab-click="changeClaimHistoryTab">
      <el-tab-pane label="项目款认领记录" name="claimHistoryInvoice"></el-tab-pane>
      <el-tab-pane label="垫付款认领记录" name="claimHistoryAdvance"></el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      ref="wMyTable" :page="page" :table-col-check="{isShow:true,name: activeTab + claimHistorySubTab + 'Payment_Info'}"
      @pageChange="handlePagePagination" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{record}">
        <el-button size="mini" type="primary" @click="handleInvoiceAdd(record)"
          v-if="!['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'].includes(role) && ['ALL','RECEIVABLES','PARTIAL_ARRIVAL'].includes(activeTab) && ['RECEIVABLES','PARTIAL_ARRIVAL'].includes(record.invoiceStatus)">
          添加到款
        </el-button>
        <el-button size="mini" type="primary"
          v-if="activeTab === 'claim' && ['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','ADMIN'].includes(role)"
          @click="claim(record)">认领</el-button>
        <el-button size="mini" type="warning"
          v-if="activeTab === 'claim' && ['ADMIN','FINANCE','CASHIER'].includes(role)"
          @click="handleEditPayment(record)">编辑</el-button>
        <el-button size="mini" type="danger"
          v-if="activeTab === 'claim' && ['ADMIN','FINANCE','CASHIER'].includes(role)" icon="el-icon-delete"
          @click="handleDelete(record)">删除</el-button>
        <el-button size="mini" type="warning"
          v-if="!['SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER'].includes(role) && ['ALL','PARTIAL_ARRIVAL','PAYMENT'].includes(activeTab) && ['PAYMENT','PARTIAL_ARRIVAL'].includes(record.invoiceStatus)"
          @click="handleEdit(record)">编辑到款</el-button>
        <el-button size="mini" type="danger"
          v-if="['ADMIN', 'MANAGER', 'FINANCE', 'CASHIER'].includes(role) && ['ALL', 'PARTIAL_ARRIVAL', 'PAYMENT'].includes(activeTab) && ['PAYMENT', 'PARTIAL_ARRIVAL'].includes(record.invoiceStatus)"
          @click="handleDeletePayment(record)">删除到款</el-button>
        <el-button size="mini" type="primary" color="#ffffff"
          v-if="record['annex']?.['CLAIM_THE_INVOICE_ANNEX'] && activeTab === 'claimHistory'" icon="el-icon-download"
          @click="download(record,'CLAIM_THE_INVOICE_ANNEX')">下载附件</el-button>
          <el-button size="mini" type="primary" color="#ffffff"
          v-if="record['annex']?.['CLAIM_THE_ADVANCE_PAYMENT_ANNEX'] && activeTab === 'claimHistory'" icon="el-icon-download"
          @click="download(record,'CLAIM_THE_ADVANCE_PAYMENT_ANNEX')">下载附件</el-button>
      </div>
      <template slot="claimTheInvoiceFlag" slot-scope="{text,record}">
        <span v-if="claimInvoiceFlag(text)" style="display: flex;align-items: center">
          <el-tag type="success">是</el-tag>
          <el-link type="primary" style="margin-left: 5px" :underline="false" @click="openPaymentsInfo(record,true)"><i
              v-html="viewDetailIcon"></i></el-link>
        </span>
        <el-tag v-else type="danger">否</el-tag>
      </template>
      <template slot="createSales" slot-scope="{record}">
        <span v-if="!(record?.initialSale?.uuid)">{{ 'NA' }}</span>
        <span v-else-if="record.applicantId === record.initialSale.uuid">{{ record.initialSale.name || '系统内未找到'
          }}</span>
        <div v-else>
          <span style="display: block; text-align: left;">销售：{{
            record.initialSale.originalPersonMap[record.applicantId]['name'] || '系统内未找到' }}(已离职)</span>
          <span style="display: block; text-align: left;">离职时间：{{
            record.initialSale.originalPersonMap[record.applicantId]['deleteTime'] || '系统内未找到' }}</span>
        </div>
      </template>
      <template slot="contractNumbers" slot-scope="{record,text,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </template>
      <template slot="status" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </template>
      <template slot="invoiceNumber" slot-scope="{record,text}" v-if="text">
        <el-link type="primary" v-if="activeTab !== 'claimHistory' || record.status !== 'DEFEAT'" :underline="false"
          @click="openInvoice(text)"><i v-html="viewDetailIcon"></i>{{ text }}
        </el-link>
        <span v-else>{{text}}</span>
      </template>
      <template slot="paymentStatus" slot-scope="{record,text}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'REJECTED'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="paymentAmount" slot-scope="{text,record,index}" v-if="text">
        <span v-for="(payment,index1) in text.filter(item => item.paymentStatus === 'DONE')">
          {{ payment.paymentAmount + (index1 !== text.filter(item => item.paymentStatus === 'DONE').length - 1 ? '/' :
          '') }}
        </span>
      </template>
      <template slot="paymentDate" slot-scope="{text,record,index}" v-if="text">
        <ex-fold-table-cell
          :scope="{text:text.filter(item => item['paymentStatus'] === 'DONE').map(item => item.paymentDate), record, index}"></ex-fold-table-cell>
      </template>
      <template slot="auditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['invoiceAuditRejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true"
            :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="refundAuditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="invoiceStatus" slot-scope="{text,record}">
        <el-tag :type="getInvoiceColor(text,'tagType')"
          :style="{color: getInvoiceColor(text,'color'),'background-color':getInvoiceColor(text,'backgroundColor')}">
          {{getInvoiceColor(text,'name')}}</el-tag>
      </template>
      <template slot="connectedFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="sameDayFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="refundTime" slot-scope="{text,record}">
        <div v-if="text">
          {{text}}
        </div>
        <div v-else>
          NA
        </div>
      </template>
      <template slot="operatingTime" slot-scope="{text,record}">
        <div v-if="text">
          {{text}}
        </div>
        <div v-else>
          NA
        </div>
      </template>
      <template slot="refundDate" slot-scope="{text,record}">
        <div v-if="text">
          {{text}}
        </div>
        <div v-else>
          NA
        </div>
      </template>
      <template slot="filterTime" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-input v-model="selectedKeys[0]" size="mini" placeholder="开始日期" style="width: 120px;">
          </el-input>
          -
          <el-input v-model="selectedKeys[1]" size="mini" placeholder="结束日期" style="width: 120px;">
          </el-input>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters,'time')">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="filterInvoice" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待开票'>待开票</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='应收款'>应收款</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已回款'>已回款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='退票成功'>退票成功</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待退票'>待退票</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='部分到款'>部分到款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='取消开票'>取消开票</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
    </w-table>

    <picture-loading v-if="loading"></picture-loading>
    <!--    认领-->
    <add-edit-payment v-if="showAddEditPayment" :show-dialog="showAddEditPayment" :select-type="selectType"
      :select-detail="selectDetail" @submit="closeAddEditPayment">
    </add-edit-payment>
    <!--    添加到款-->
    <add-payment v-if="showAddPayment" :show-dialog="showAddPayment" :select-detail="selectDetail"
      :tabClassify="activeTab" :Info="selectInfo" :type="type" @submit="closeAddPayment"></add-payment>
    <tickets-details v-if="showInvoice" :show-dialog="showInvoice" :select-detail="InvoiceInfos" show-payment="payment"
      @submit="close"></tickets-details>
    <payments-info v-if="showPayments" :show-dialog="showPayments" :claim-infos="claimInfos" :invoice-info="ticketsInfo"
      :payments-info="paymentsInfos" @submit="closeShowPayments"></payments-info>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
   <batch-add-pending-payment v-if="batch.showDialog" :show-dialog="batch.showDialog" :type="batch.type"
      :select-detail="batch.selectDetail" @submit="closeBatch"></batch-add-pending-payment>
  </div>
</template>

<script>
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {payment} from "@/utils/data/tableCol/info/payment/payment";
import { getPaymentPage} from "@/api/dilivery/payment";
import AddEditPayment from "@/components/info/payment/AddEditPayment.vue";
import AddPayment from "@/components/info/payment/AddPayment.vue";
import { exportInvoice, getTicketsPage} from "@/api/dilivery/tickets";
import TicketsDetails from "@/components/tickets/TicketsDetails.vue";
import { getDataInLocalStorage, saveDataToLocalStorage } from "@/utils/localStorage";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import Template from "@/views/systems/Template/Template";
import {viewDetailIcon} from "@/utils/icon";
import {ticket} from "@/utils/data/tableCol/tickets/ticket";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import {getAuditPage} from "@/api/dilivery/audit";
import { PaymentAudit } from "@/utils/data/tableCol/audit/Payment/PaymentAudit";
import PaymentsInfo from "@/components/info/payment/PaymentsInfo.vue";
import ExportComponents from "@/components/ExportComponents.vue";
import {getUserPage} from "@/api/dilivery/customer/user";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import {getInvoiceColor, getStatusColor} from "@/color";
import BatchAddPendingPayment from "@/components/info/pending-payment/BatchAddPendingPayment.vue";
import { AdvanceAudit } from "@/utils/data/tableCol/audit/Advance/AdvanceAudit";
import { getPendingPaymentPage, deletePendingPayment } from "@/api/dilivery/pending-payment";
import {pendingPayment} from "@/utils/data/tableCol/info/pending-payment/pending-payment";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "PaymentInfo",
  components: {
    CustomerUserInfo,
    ExportComponents,
    PaymentsInfo, BatchAddPendingPayment,
    PictureLoading, Template, TicketsDetails, ExFoldTableCell, AddPayment, AddEditPayment, TableHeadNote
  },
  mixins:[tableOperationMixin],
  data() {
    return {
      role: '',
      activeTab: '',
      claimHistorySubTab: 'claimHistoryInvoice',
      tableData: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: 0
      },
      searchConditionTag: [],
      sortConditionTag: [],
      selectable: [],
      loading: true,
      option:[
        {label:'到款时间',value:'arrivalTime'},
        {label:'退票申请时间',value:'refundTime'},
        {label:'退票日期',value:'refundDate'},
        {label:'退票审核日期',value:'operatingTime'},
        {label:'开票日期',value:'invoiceDate'},
        {label:'创建时间',value:'createTime'},
      ],
      contactInfo:[],
      showContactInfo:false,
      selectInfo: {},
      rowSelectData:[],
      viewDetailIcon: viewDetailIcon,
      showAddEditPayment: false,
      showAddPayment: false,
      selectType: {},
      selectDetail: '',
      InvoiceInfos: '',
      type:'',
      showInvoice: false,
      showPayments:false,
      claimInfos:[],
      ticketsInfo:{},
      paymentsInfos:[],
      batch: {
        showDialog: false,
        type: '',
        selectDetail: []
      },
      pageTotal:{
        RECEIVABLES:'',
        PARTIAL_ARRIVAL: '',
        claim: '',
      },
      claimData: {
        showDialog: false,
        selectDetail: {}
      },
      isShowPayment: true,
    }
  },   
  created() {
    this.role = getDataInLocalStorage('role');
    this.activeTab = ['SALES_MANAGER', 'SALES_ASSI','SALES_ASSI_MANAGER', 'SALES'].includes(this.role) ? 'claim' : 'ALL';
    this.isShowPayment = getDataInLocalStorage('isShowPayment') === 'true'
  },
  computed: {
    columns() {
      if (['claim'].includes(this.activeTab)) {
        return JSON.parse(JSON.stringify(pendingPayment([] || {}, this.activeTab)))
      } else if (['deleteHistory'].includes(this.activeTab)) {
        let cols = payment([] || {}).filter(item => !['operation'].includes(item.key))
        return JSON.parse(JSON.stringify(cols))
      } else if (this.activeTab === 'claimHistory') {
        if (this.claimHistorySubTab === 'claimHistoryAdvance') {
          return JSON.parse(JSON.stringify(AdvanceAudit([] || {})))
        } else {
          return JSON.parse(JSON.stringify(PaymentAudit([] || {}, 'ALL')))
        }
      } else {
        return JSON.parse(JSON.stringify(ticket([] || {})))
      }
    }
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  watch: {
    '$route.params.payment': {
      handler(newVal) {
        if (newVal) {
          this.searchConditionTag = JSON.parse(newVal)
          this.activeTab = 'ALL';
          this.getData('search')
          this.$nextTick(() => {
            if (this.$refs.wMyTable) {
              this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
            }
          });
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    // 组件销毁前执行清理逻辑
    saveDataToLocalStorage('isShowPayment', !!this.isShowPayment)
  },
  methods: {
    getStatusColor,
    getInvoiceColor,
    exportInvoice,
    closeShowPayments(){
      this.$nextTick(() =>{
        this.showPayments = false
      })
      this.paymentsInfos = []
      this.claimInfos = []
      this.ticketsInfo = {}
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    changeShowWechat() {
      this.isShowPayment = !this.isShowPayment
    },
    showContact(contactName){
      let data = {
        "query#contactName.IN":contactName.join(',')
      }

      getUserPage({},data).then(res => {
        if(res.code === 200){
          this.contactInfo = res.data.records
          this.showContactInfo = true
        }else{
          this.showContactInfo = false
        }
      }).catch(err =>{
        this.showContactInfo = false
      })
    },
    loadAllTabTotals() {
      const tabConfigs = {
        RECEIVABLES: { api: getTicketsPage, sendData: { "query#invoiceStatus.EQ": "RECEIVABLES" } },
        PARTIAL_ARRIVAL: { api: getTicketsPage, sendData: { "query#invoiceStatus.EQ": "PARTIAL_ARRIVAL" } },
        claim: { api: getPendingPaymentPage, sendData: {} },
      }
      Object.keys(tabConfigs).forEach(tabName => {
        tabConfigs[tabName].api({ 'page.current': 1, 'page.size': 1 }, tabConfigs[tabName].sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    getSearchData(sendData){
      this.searchConditionTag = []
      if (sendData && Object.keys(sendData).length) {
        this.searchConditionTag.push(sendData)
      }
      this.getData('search')
    },
    claimInvoiceFlag(text){
      if(!text || text.length === 0){
        return false
      }
      return text.map(item => item['claimTheInvoiceFlag']).includes(true)
    },
    closeBatch() {
      this.batch.showDialog = false
      this.batch.type = ''
      this.batch.selectDetail = []
      this.getData('search')
    },
    async openPaymentsInfo(row,flag) {
      try{
        if(flag){
          let params = {
            'page.current': 1,
            'page.size': 100,
          };
          let data = {
            "query#dataKey.IN":row.payments.map(item => item.id).join(','),
            "query#status.EQ":"SUCCESS"
          }
          const response = await getAuditPage(params, data, 'CLAIM_INVOICE_AUDIT')
          if(response.code === 200){
            this.claimInfos = response.data.records
          }
        }
        this.paymentsInfos = row.payments.filter(item => !item['claimTheInvoiceFlag'])
        this.ticketsInfo = row
        this.showPayments = true
      } catch (error) {
        console.log(error);
        this.$messageUi.error('获取到款信息失败')
        this.$nextTick(() => {
          this.claimInfos = []
          this.paymentsInfos = []
          this.ticketsInfo = {}
          this.showPayments = false
        })
      }
    },
    changeTab(tab) {
      this.selectable = []
      this.tableData = []
      if (tab === 'claimHistory') {
        this.claimHistorySubTab = 'claimHistoryInvoice'
      }
      this.getData('search')
    },
    changeClaimHistoryTab(tab) {
      this.selectable = []
      this.tableData = []
      this.getData('search')
    },
    handleInvoiceAdd(row) {
      if (row) {
        this.selectDetail = [row]
      } else {
        const selectable = this.selectable.filter(item => ['RECEIVABLES','PARTIAL_ARRIVAL'].includes(item.invoiceStatus))
        if (selectable.length > 0) {
          this.selectDetail = selectable
        } else {
          this.$messageUi.error('请勾选还未完全到款的发票信息')
          return
        }
      }
      this.type = 'add'
      this.showAddPayment = true
    },
    async download(row,type) {
      try {
        let url = `${baseURL}/audit-info/attachment/${row.id}/${type}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    handleEditPayment(row){
      this.selectDetail = row
      this.selectType = {
        type: 'edit'
      }
      this.showAddEditPayment = true
    },
    handleDelete(row) {
      let ids;
      if (row) {
        ids = [row.id]
      } else {
        ids = this.selectable.map(item => item.id)
        if (ids.length <= 0) {
          this.$messageUi.error('请勾选要删除的的待认领到款数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          "ids" : ids.join(',')
        }
        deletePendingPayment(param).then(res => {
          if (res.code === 200) {
            this.$store.commit('right/setChangeRed',true)
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.getData('search')
          }
        }).catch(err => {
        })
      }).catch(() => {})
    },
    claim(row) {
      this.selectDetail = {...row}
      this.selectType = {
        type: 'claim'
      }
      this.showAddEditPayment = true
    },
    //表格的选择框
    rowSelection(selectedRows) {
      this.selectable = selectedRows
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    openInvoice(invoiceNumber) {
      let data = {
        "query#invoiceNumber.EQ":invoiceNumber
      }
      getTicketsPage({}, data).then(res => {
        if (res.code === 200) {
          this.InvoiceInfos = res.data.records[0]
          this.showInvoice = true
        }
      }).catch(err => {
        this.$nextTick(() => {
          this.showInvoice = false
        });
      })
    },
    // 获取数据
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let tab = this.activeTab
      if (tab === 'claimHistory') {
        tab = this.claimHistorySubTab
      }
      let sendData = this.getBaseSendData(tab)
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }

      let ApiMethod = getTicketsPage
      let auditType = 'CLAIM_INVOICE_AUDIT'
      if (['claim'].includes(tab)) {
        ApiMethod = getPendingPaymentPage
      } else if (tab === 'claimHistoryAdvance') {
        ApiMethod = getAuditPage
        auditType = 'ADVANCE_PAYMENT_CLAIM_AUDIT'
      } else if (tab === 'claimHistoryInvoice') {
        ApiMethod = getAuditPage
        auditType = 'CLAIM_INVOICE_AUDIT'
      } else if (['deleteHistory'].includes(tab)) {
        ApiMethod = getPaymentPage
      }

      ApiMethod(params, sendData, auditType).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.$set(this.pageTotal, tab, parseInt(res.data.total))
          if (['claimHistoryAdvance', 'claimHistoryInvoice'].includes(tab)) {
            this.tableData = res.data.records.map(item => ({ ...item, dataRaw: item.rawData ? JSON.parse(item.rawData) : {} }))
          } else {
            this.tableData = res.data.records;
          }
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(err => {
        console.log(err);
        this.loading = false
      })
    },
    getBaseSendData(activeTab = this.activeTab) {
      switch (activeTab) {
        case 'ALL':
          return {"query#invoiceStatus.IN": "RECEIVABLES,PARTIAL_ARRIVAL,PAYMENT"}
        case 'RECEIVABLES':
          return {"query#invoiceStatus.EQ": "RECEIVABLES"}
        case 'PARTIAL_ARRIVAL':
          return {"query#invoiceStatus.EQ": "PARTIAL_ARRIVAL"}
        case 'PAYMENT':
          return {"query#invoiceStatus.EQ": "PAYMENT"}
        case 'claim':
          return {}
        case 'claimHistoryInvoice':
          return { "query#status.IN": "APPLYING,SUCCESS,DEFEAT" }
        case 'claimHistoryAdvance':
          return {"query#status.IN": "APPLYING,SUCCESS,DEFEAT"}
        case 'deleteHistory':
          return {"query#paymentStatus.EQ": "DELETED"}
        default:
          return {}
      }
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if(['refundAuditStatus','statusType','status'].includes(item.key)){
          if(item.value === '待审核'){
            value = 'APPLYING'
          }else if(item.value === '已通过') {
            value = 'SUCCESS'
          }else{
            value = 'DEFEAT'
          }
        }else if (item.key === 'invoiceStatus'){
          if(item.value === '待审核'){
            value = 'PENDING_AUDIT'
          }else if(item.value === '待开票'){
            value = 'PENDING_INVOICE'
          }else if(item.value === '应收款'){
            value = 'RECEIVABLES'
          }else if(item.value === '已回款'){
            value = 'PAYMENT'
          }else if(item.value === '退票成功'){
            value = 'REFUND_SUCCESS'
          }else if(item.value === '部分到款'){
            value= 'PARTIAL_ARRIVAL'
          }else if(item.value === '取消开票'){
            value = 'CANCEL_INVOICING'
          } else{
            value = 'PENDING_REFUND'
          }
        } else if (['contractNumber','contractNumbers'].includes(item.key)) {
          value = value.replace(/[A-Za-z]/g, "")
        } else if (item.key === 'arrivalTime') {
          value = value.split('至').join(',')
        }
        if (item.key === 'invoiceTitle') {
          sendData["query#" + item.key + ".LIKE"] = value
        }
        if(['invoiceRecordNumber','statusType','invoiceTitle','contractNumber','contractNumbers','salesName','invoicingPrincipal','billingUnitName','contactName','theAmountReceived','arrivalTime','receivingUnit','initialSalesName','saleName'].includes(item.key)){
          sendData[item.key] = value
        } else if(this.option.map(it => it.value).includes(item.key)){
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else if (item.key !== 'contact') {
          sendData["query#" + item.key + ".LIKE"] = value
        } else {
          sendData["query#id.IN"] = item.label.join(',')
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑
    handleEdit(row) {
      this.type = 'edit'
      this.selectInfo = row
      this.showAddPayment = true
    },
    handleDeletePayment(row) {
      this.type = 'delete'
      this.selectInfo = row
      this.showAddPayment = true
    },
    handleAdd() {
      this.batch.showDialog = true
      this.batch.type = 'add'
      this.batch.selectDetail = []
    },
    // 关闭编辑、增加、批量添加弹出框
    closeAddEditPayment(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddEditPayment = false
      });
    },
    closeAddPayment(type) {
      this.selectInfo = {}
      this.selectDetail = []
      this.$nextTick(() => {
        if (type === 'confirm') {
          this.$refs.wMyTable.selectedRowKeys = this.selectable.map(item => item.id)
        }
        this.getData()
        this.showAddPayment = false
      });
    },
    close() {
      this.$nextTick(() => {
        this.showInvoice = false
      })
    },
  }
}
</script>

<style scoped>
/* 垫付款认领流程图容器：SVG 按 viewBox 等比缩放，限制最大宽度以整体缩小展示 */
.payment-flowchart {
  width: 100%;
  overflow-x: auto;
  padding: 4px 0;
}
.payment-flowchart svg {
  display: block;
  width: 100%;
  max-width: 1100px;
  min-width: 720px;
  height: auto;
  margin: 0 auto;
}
</style>
